import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'

export const CrudDataTypeEnum = { ...ActionTypeEnum }
export type CrudDataTypeEnum = ActionTypeEnum
